import React, { useState, useEffect } from 'react';
import { FloatButton } from 'antd';

import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Earning } from './components/Earning';
import { Features } from './components/Features';
import { Products } from './components/Products';
import { RegardingHybridNodes } from './components/RegardingHybridNodes';
import { Community } from './components/Community';
import { AIUseCases } from './components/AIUseCases';
import { CommunityJoin } from './components/CommunityJoin';
import { BoundlessComputing } from './components/BoundlessComputing';
import { Footer } from './components/Footer';
import '../i18n.ts';

export type NavbarData = {
  h5: string,
  android: string,
  ios: string,
  client: string,
  whitePaper: Array<{
    label: string,
    href: string
  }>,
  contactUrl: Array<{
    label: string,
    href: string
  }>
}

function App() {
  const [navbarData, setNavbarData] = useState<NavbarData>({
    "h5": "",
    "android": "",
    "ios": "",
    "client": "",
    "whitePaper": [],
    "contactUrl": [
    ]
  })

  const getNavbarData = async () => {
    try {
      const { protocol, hostname, port } = window.location;
      const url = `${protocol}//${hostname}${port ? ':' + port : ''}`
      const jsonUrl = url + '/download-config.json';
      const response = await fetch(jsonUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      setNavbarData(result)
    } catch (err: any) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    getNavbarData();
  }, [])

  return (
    <div className="min-h-screen bg-black text-white font-sans overflow-x-clip">
      <Header navbarData={navbarData} />
      <main>
        <Hero navbarData={navbarData} />
        <Earning />
        <Features />
        <Products />
        <RegardingHybridNodes />
        <Community />
        <AIUseCases />
        <CommunityJoin navbarData={navbarData} />
        <BoundlessComputing />
      </main>
      <Footer />
      <FloatButton.BackTop />
    </div>
  );
}

export default App;
